import * as React from 'react';
import type { SidebarContextProps } from '@/shared/ui/sidebar/sidebar-context-props';

export const SidebarContext = React.createContext<SidebarContextProps | null>(null);
